import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { ToastComponent } from './components/toast/toast.component';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule
  ],
  declarations: [
    ToastComponent
  ],
  exports: [],
  entryComponents: [
    ToastComponent
  ]
})
export class McRAIToasterModule { }
